// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_style_checkbox__eA24l","rotate":"Checkbox_style_rotate__iwuV3"};